import { render } from "./Fileupload.vue?vue&type=template&id=32d3e0c4"
const script = {}

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__